/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Organization } from './organization';
import { UserName } from './userName';


/**
 * Row of the practices tab of the configuration page.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface PracticeList { 
    readonly id: number;
    name: string;
    readonly organizations: Array<Organization>;
    street?: string;
    houseNumber?: string;
    postalCode?: string;
    city?: string;
    readonly owner: UserName | null;
    readonly address: string;
}
export const PracticeList_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PracticeList_name_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.maxLength(1023),];

export const PracticeList_organizations_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PracticeList_street_Validators: ValidatorFn[] =
    [  Validators.maxLength(255),];

export const PracticeList_houseNumber_Validators: ValidatorFn[] =
    [  Validators.maxLength(31),];

export const PracticeList_postalCode_Validators: ValidatorFn[] =
    [  Validators.maxLength(10),];

export const PracticeList_city_Validators: ValidatorFn[] =
    [  Validators.maxLength(255),];

export const PracticeList_owner_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PracticeList_address_Validators: ValidatorFn[] =
    [  Validators.required, ];


